module.exports = __webpack_public_path__ + "img/rencai.6d6ac405.jpg";